import React, { Component } from 'react'
import styles from "./GridBox.module.css"
import { v4 as uuidv4 } from 'uuid';
import SplitPane from "react-splitter-layout";
import ExtendBlock from "../../util/ExtendBlock/ExtendBlock";
import "../../util/ExtendBlock/SplitterStyle.css"

export default class GridBox extends Component {
    constructor(props) {
        super(props)

        this.state = {
            contentUpdate: 0
        }

        this.gridRef = null
        this.layoutDict = {
            vertical: this.props.vertical,
            uuidFirst: null, uuidSecond: null,
            firstObject: null, secondObject: null
        }
    }
    // Handler
    updateLayout = (dict = {
        vertical: true,
        uuidFirst: null, uuidSecond: null,
        firstObject: null, secondObject: null
    }) => {
        var newLayout = null
        var jsxFirst = null
        var jsxSecond = null
        let uuid1 = null
        let uuid2 = null
        var primaryLayout = 0
        // udpate first layout
        if (dict.uuidFirst == 'object') {
            jsxFirst = this.updateLayout(dict.firstObject)
        } else if (dict.uuidFirst != null) {
            uuid1 = dict.uuidFirst
            var extState = this.getExtendState(uuid1)
            jsxFirst =
                <ExtendBlock key={uuid1} id={uuid1}
                    childState={extState}
                    dirClickHandler={(e, clickDir) => this.expandGridLayout(e, clickDir, dict.vertical, uuid1)}
                    selectHandler={(e) => this.selectHandler(e, uuid1)}
                    removeHandler={(e) => this.removeHandler(e, uuid1)}>
                    {this.props.content[uuid1]}
                </ExtendBlock>
        }

        // udpate second layout
        if (dict.uuidSecond == 'object') {
            jsxSecond = this.updateLayout(dict.secondObject)
        } else if (dict.uuidSecond != null) {
            uuid2 = dict.uuidSecond
            var extState = this.getExtendState(uuid2)
            jsxSecond =
                <ExtendBlock key={uuid2} id={uuid2}
                    childState={extState}
                    dirClickHandler={(e, clickDir) => this.expandGridLayout(e, clickDir, dict.vertical, uuid2)}
                    selectHandler={(e) => this.selectHandler(e, uuid2)}
                    removeHandler={(e) => this.removeHandler(e, uuid2)}>
                    {this.props.content[uuid2]}
                </ExtendBlock>
        }

        // merge as one layout
        if (dict.newId != false) {
            if (uuid1 == dict.newId)
                primaryLayout = 1;
            dict.newId = false
        }

        newLayout =
            <SplitPane
                vertical={dict.vertical}
                borderColor="#999"
                percentage={false}
                primaryIndex={primaryLayout}
            >
                {[jsxFirst, jsxSecond]}
            </SplitPane>

        return (newLayout)
    }

    findDict = (dict, uuid, newLayout = {}) => {
        var result = false

        if (dict.uuidFirst == 'object') {
            result = this.findDict(dict.firstObject, uuid, newLayout)
        } else if (dict.uuidFirst == uuid) {
            dict.uuidFirst = "object"
            dict.firstObject = { ...newLayout }
            result = true
        }

        if (result == false) {
            if (dict.uuidSecond == 'object') {
                result = this.findDict(dict.secondObject, uuid, newLayout)
            } else if (dict.uuidSecond == uuid) {
                dict.uuidSecond = "object"
                dict.secondObject = { ...newLayout }
                result = true
            }
        }
        return result;
    }

    expandGridLayout = (e, clickDir, vertical, uuid) => {
        // console.log(clickDir, vertical, uuid)

        var newUuid = uuidv4()
        this.props.createContentHandler(newUuid)
        // new layout dict
        var newLayout = {
            vertical: (clickDir == "TOP" || clickDir == "BOTTOM") ? true : false,
            uuidFirst: (clickDir == "TOP" || clickDir == "LEFT") ? newUuid : uuid,
            uuidSecond: (clickDir == "BOTTOM" || clickDir == "RIGHT") ? newUuid : uuid,
            firstObject: null,
            secondObject: null,
            newId: newUuid
        }
        this.findDict(this.layoutDict, uuid, newLayout)

        this.setState(state => {
            return {
                contentUpdate: state.contentUpdate + 1
            }
        })
    }

    mountFirstLayout = () => {
        var vertical = this.props.vertical
        var uuid = uuidv4()
        this.props.createContentHandler(uuid)
        this.layoutDict = {
            vertical: vertical,
            uuidFirst: uuid,
            uuidSecond: null,
            firstObject: null,
            secondObject: null,
            newId: null
        }

        // setState
        this.setState(state => { return { contentUpdate: state.contentUpdate + 1 } })
    }
    selectHandler = (e, id) => {
        this.props.selectHandler(id)
    }

    removeDict = (dict, uuid) => {
        var sibling = {}

        if (dict.uuidFirst == 'object') {
            var result = this.removeDict(dict.firstObject, uuid)

            if (result.uuid) {
                dict.uuidFirst = result.uuid
                dict.firstObject = result.obj
                return sibling
            }

        } else if (dict.uuidFirst == uuid) {
            //remove it
            sibling = { uuid: dict.uuidSecond, obj: dict.secondObject }

            return sibling;
        }

        if (dict.uuidSecond == 'object') {
            var result = this.removeDict(dict.secondObject, uuid)

            if (result.uuid) {
                dict.uuidSecond = result.uuid
                dict.secondObject = result.obj
                return sibling
            }
        } else if (dict.uuidSecond == uuid) {
            //remove it
            sibling = { uuid: dict.uuidFirst, obj: dict.firstObject }

            return sibling;
        }

        return sibling;
    }
    removeHandler = (e, id) => {
        this.removeDict(this.layoutDict, id)
        // this.props.reserveComponent(uuid)
        this.props.removeContent(id)
        this.setState(state => { return { contentUpdate: state.contentUpdate + 1 } })
    }

    getExtendState = (id) => {
        var extendState = {}
        if (this.props.contentState) {
            if (this.props.contentState[id] && this.props.contentState[id].state)
                extendState = this.props.contentState[id].state
        }
        return extendState
    }
    // life cycle handler
    componentDidMount() {
        this.mountFirstLayout()
    }
    mountGridRef = (ref) => {
        this.gridRef = ref
    }
    render() {
        const style = { height: (this.props.height) ? this.props.height : "100vh" }
        const compList = this.updateLayout(this.layoutDict)

        return (
            <div id={this.props.id} className={styles.container} style={style} dir={this.props.dir}>
                {compList}
            </div>
        )
    }
}
